/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const CmpButtonTalkTo = ({
  property1,
  text = "Chat to Cedar about this",
}) => {
  return (
    <div className="cmp-button-talk-to">
      <p className="chat-to-cedar-about">{text}</p>
    </div>
  );
};

CmpButtonTalkTo.propTypes = {
  property1: PropTypes.oneOf(["default"]),
  text: PropTypes.string,
};
